// extracted by mini-css-extract-plugin
export default {"activeLink":"FooterNavBar_activeLink__ba1dY","unselected":"FooterNavBar_unselected__xbCd3","footerArea":"FooterNavBar_footerArea__xybLE"};